import { render, staticRenderFns } from "./editGiftGoods.vue?vue&type=template&id=3d48c709&scoped=true"
import script from "./editGiftGoods.vue?vue&type=script&lang=js"
export * from "./editGiftGoods.vue?vue&type=script&lang=js"
import style0 from "./editGiftGoods.vue?vue&type=style&index=0&id=3d48c709&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d48c709",
  null
  
)

export default component.exports